import { ReviewRow, ReviewMediaRow } from '../ReviewRow/ReviewRow'

const ReviewDisplayContentTab = ({ activeLanguage, salesTargetData }) => {
  const { displayContent, displayContentMedia ,media} = salesTargetData
  const imageUri = displayContentMedia?.imageUri || displayContentMedia?.imageUrl || '';
  const data = displayContent?.[activeLanguage] || {}
  const getAnswer = val => (val? 'Yes' : 'No')
  return (
    <div data-testid="ReviewdisplayContentForm">
      <div className="review_subtitle mtb30">Display</div>
      <div className="grid">
        <div className="grid_wrap">
          <ReviewRow data-testid="display-title-label" label="Title" value={data.title} />
          <ReviewRow data-testid="display-category-label" label="Category For Target Title" value={data?.category} />
          <ReviewRow label="Excerpt" value={data.excerpt} />
          <ReviewRow label="Terms" value={data.terms} />
        </div>
      </div>

      {imageUri && imageUri !== '' &&
        <>
          <div className="review_subtitle">Media</div>
          <div className="grid grid-cols-2">
            <div className="grid_wrap">
              <a href={imageUri} download={"display_content_image.png"} className="review_image_row grid grid-cols-2 gap-y-2 cursor-pointer" >
                <img src={imageUri} alt="Pepsi Logo" />
              </a>
              <ReviewMediaRow data-testid="display-title-label" label="Title" value={displayContentMedia?.title} />
              <ReviewMediaRow label="Opt In" value={getAnswer(media[0]?.optIn)} />
            </div>
          </div>
        </>
      }
    </div >
  )
}

export default ReviewDisplayContentTab
